import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/service/${dossierId}/relatedHistorical`, method: 'GET', token: token })
}
